import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Reminders_DeleteReminder, Reminders_GetReminderDetail, Reminders_GetReminders, Reminders_InsertEditReminder } from '../../Services/Actions';
import { toast } from 'react-toastify';
import moment from 'moment';
import DateTime from 'react-datetime';
import { RRule } from 'rrule';

import Languages from '../../Config/languages';

import * as styles from './styles';

import Loading from '../../Components/Loading';

import AssignClients from '../../Components/AssignClients';
import ButtonGroup from '../../Components/Buttons/ButtonGroup';
import RRuleGenerator from '../../Components/Calendar/RRuleGenerator';
import MultiText from '../../Components/Text/MultiText';
import Page from '../../Components/Page';
import PageText from '../../Components/Text/PageText';
import Spacer from '../../Components/Spacer';

import Info from '../../Modals/Info';

function buildClientText({ ClientDisplay, IsAllClients, NumClients, t }) {
    var ClientText;

    if (+IsAllClients === 1) ClientText = `🌐 ${t('all_clients')}`;
    else if (+NumClients >= 2) ClientText = `👥 ${NumClients} ${t('clients')}`
    else ClientText = `👤 ${ClientDisplay}`;

    return ClientText;
}

function BuildRecurrencePatternHumanString({ options = {}, RecurrencePattern: RRuleString }) {
    const rule = RRule.fromString(RRuleString);

    const {
        timeFormat = 'HH:mm a',
        includeSeconds = false,
    } = options
  
    const baseText = rule.toText()
  
    const { dtstart } = rule.options;
  
    let hour = dtstart.getHours();
    let minute = dtstart.getMinutes();
  
    // If no usable time, return original text
    if (hour == null || minute == null) {
        return baseText
    }
  
    const time = moment()
        .hour(hour)
        .minute(minute)
        .format(includeSeconds ? 'HH:mm:ss' : timeFormat)
  
    // Remove "at X" added by rrule.toText()
        const cleanedText = baseText.replace(/\s+at\s+\d+\b.*$/, '')
  
    return `${cleanedText} at ${time}`
}

function buildRecurrencePatternWithDtStart(rrule, localDate) {
    function pad(n) {
        return String(n).padStart(2, '0');
    }

    localDate = new Date(localDate);
  
    // Convert local date → UTC components
    var year = localDate.getUTCFullYear();
    var month = pad(localDate.getUTCMonth() + 1);
    var day = pad(localDate.getUTCDate());
    var hour = pad(localDate.getUTCHours());
    var minute = pad(localDate.getUTCMinutes());
    var second = pad('');
  
    const dtstart = 'DTSTART:' + year + month + day + 'T' + hour + minute + second + 'Z';
    
    // If rrule already has a DTSTART, replace it; otherwise add at top
        if (/^DTSTART:/m.test(rrule)) {
            return rrule.replace(/^DTSTART:[^\n]+/m, dtstart);
        } else {
            return dtstart + '\n' + rrule;
        }
}

const DEFAULT_MESSAGE_DATA =  {
    ReminderId: 0,
    ReminderMessage: '',
    Type: '',
    DueAt: new Date(),
    ClientList: [],
    IsAllClients: null,
    RecurrencePattern: '',
    SelectedUsers: [],
    SelectedUserIds: [],
    OneTimeSendNow: 1
}

class MessageScheduler extends React.Component {
    _isMounted = false;

    state = {
        DateFormat: 'MM-DD-YYYY',
        TimeFormat: 'hh:mm a',

        Messages: [],

        ShowDeleteMessageModal: false,
        ShowDeleteMessageModal_Details: {},
        ShowSendMessageModal: false,
        ShowSendMessageModal_Details: {}
    }

    componentDidMount() {
        this._isMounted = true;

        var { LanguageId } = this.props.UserDetails;

        this.setState({
            DateFormat: Languages[`${LanguageId}`] ? Languages[`${LanguageId}`].longDateFormat["[NumbersDate]"] : Languages[`1`].longDateFormat["[NumbersDate]"],
            TimeFormat: Languages[`${LanguageId}`] ? Languages[`${LanguageId}`].longDateFormat["[TrackingHistoryTime]"] : Languages[`1`].longDateFormat["[TrackingHistoryTime]"],
            Locale: LanguageId === 2 ? 'nb' : 'en'
        }, () => this.onGetMessages());
    }

    onChangeScheduleMessage_ClientList = ({ SelectedClients: SelectedUsers }) => {
        // console.log('selected users: ', SelectedUsers);
        var SelectedUserIds_New = SelectedUsers.map(User => User.UserId);
        SelectedUsers = SelectedUsers.map(User => ({ ...User, Sex: User.Gender }));

        var ShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details, SelectedUsers, SelectedUserIds: SelectedUserIds_New };

        this.setState({ ShowSendMessageModal_Details });
    }

    onChangeScheduleMessage_IsAllClients = IsAllClients => {
        var ShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details, IsAllClients };

        this.setState({ ShowSendMessageModal_Details });
    }

    onChangeScheduleMessage_Message = event => {
        var ShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details, ReminderMessage: event.target.value };

        this.setState({ ShowSendMessageModal_Details });
    }

    onChangeScheduleMessage_OneTimeSendNow = OneTimeSendNow => {
        var ShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details, OneTimeSendNow };

        this.setState({ ShowSendMessageModal_Details });
    }

    onChangeScheduleMessage_RecurrencePattern = RecurrencePattern => {
        var ShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details, RecurrencePattern };
        
        this.setState({ ShowSendMessageModal_Details });
    }

    onChangeScheduleMessage_ScheduleType = Type => {
        var ShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details, Type };

        this.setState({ ShowSendMessageModal_Details });
    }

    onChangeScheduleMessage_StartDatetime = DueAt => {
        var ShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details, DueAt };

        this.setState({ ShowSendMessageModal_Details });
    }

    onDeleteMessage = () => {
        var { UserId } = this.props.UserDetails;
        var { ReminderId } = this.state.ShowDeleteMessageModal_Details;

        this.onToggleShowDeleteMessageModal({ ShowDeleteMessageModal: false });

        this.props.Reminders_DeleteReminder({ ReminderId, UserId }).then(() => {
            this.onGetMessages();

            toast.success(this.props.t('message_deleted'), {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });
    }

    onGetMessages = () => {
        var UserId = this.props.UserDetails.UserId;

        this.props.Reminders_GetReminders({ UserId }).then(({ Reminders }) => {
            this.setState({ Messages: Reminders.InAppMessage });
        });
    }

    onInsertEditReminder = () => {
        var { UserId } = this.props.UserDetails;
        var { DueAt, IsAllClients, OneTimeSendNow, RecurrencePattern, ReminderId, ReminderMessage, SelectedUserIds, Type } = this.state.ShowSendMessageModal_Details;

        var ClientList = [];
        if (+IsAllClients === 0) ClientList = [ ...SelectedUserIds ];

        RecurrencePattern = buildRecurrencePatternWithDtStart(RecurrencePattern, DueAt);

        if (Type.toLowerCase() === 'one_time' && +OneTimeSendNow === 1) DueAt = new Date();
        DueAt = moment.utc(DueAt).seconds(0).milliseconds(0);

        if (Type.toLowerCase() === 'one_time') RecurrencePattern = '';

        this.props.Reminders_InsertEditReminder({ ClientList, DueAt, IsAllClients, RecurrencePattern, ReminderId, ReminderMessage, ReminderType: 'InAppMessage', Type, UserId }).then(() => {
            this.onToggleShowSendMessageModal({ ShowSendMessageModal: false });

            toast.success(this.props.t('messages_scheduled'), {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            this.onGetMessages();
        });
    }

    onToggleShowDeleteMessageModal = ({ ShowDeleteMessageModal, ShowDeleteMessageModal_Details = {} }) => {
        this.setState({ ShowDeleteMessageModal, ShowDeleteMessageModal_Details });
    }

    onToggleShowSendMessageModal = ({ ShowSendMessageModal = false, ShowSendMessageModal_Details }) => {
        if (!ShowSendMessageModal) ShowSendMessageModal_Details = { ...DEFAULT_MESSAGE_DATA };

        this.setState({ ShowSendMessageModal, ShowSendMessageModal_Details }, () => {
            if (!!ShowSendMessageModal && +ShowSendMessageModal_Details.IsAllClients !== 1 && !!+ShowSendMessageModal_Details.ReminderId) {
                this.props.Reminders_GetReminderDetail({ ReminderId: ShowSendMessageModal_Details.ReminderId }).then(({ ReminderDetail }) => {
                    var NewShowSendMessageModal_Details = { ...this.state.ShowSendMessageModal_Details };
                    NewShowSendMessageModal_Details.SelectedUsers = [ ...ReminderDetail.SelectedUsers ];

                    this.setState({ ShowSendMessageModal_Details: NewShowSendMessageModal_Details }, () => console.log('ShowSendMessageModal_Details: ', this.state.ShowSendMessageModal_Details));
                })
            }
        });
    }

    renderMessages = () => {
        var { t } = this.props;
        var { Messages } = this.state;

        if (Messages.length === 0) return <div>{t('_no_results')}</div>

        return (
            <styles.MessagesContainer className="MessagesContainer">
                <styles.MessagesTable className="MessagesTable">
                    <styles.MessagesTableHeader className="MessagesTableHeader">
                        <styles.MessagesColumn_Recipients className="MessagesColumn_Recipients">{t('recipients')}</styles.MessagesColumn_Recipients>
                        <styles.MessagesColumn_Message className="MessagesColumn_Message">{t('message')}</styles.MessagesColumn_Message>
                        <styles.MessagesColumn_Scheduled className="MessagesColumn_Scheduled">{t('next_scheduled')}</styles.MessagesColumn_Scheduled>
                        <styles.MessagesColumn_Recurrence className="MessagesColumn_Recurrence">{t('recurrence')}</styles.MessagesColumn_Recurrence>
                        <styles.MessagesColumn_Actions className="MessagesColumn_Actions">{t('action')}</styles.MessagesColumn_Actions>
                    </styles.MessagesTableHeader>
                    <styles.MessagesTableBody className="MessagesTableBody">
                        {
                            Messages.map(MessageItem => {
                                var { ClientDisplay, DueAt, IsAllClients, Message, NumClients, RecurrencePattern, ReminderId, Type } = MessageItem;

                                var ClientText = buildClientText({ ClientDisplay, IsAllClients, NumClients, t });
                                var RecurrencePatternString = '';
                                if (Type === 'RECURRING') RecurrencePatternString = BuildRecurrencePatternHumanString({ RecurrencePattern });

                                return (
                                    <styles.MessagesTableRow className="MessagesTableRow" key={ReminderId}>
                                        <styles.MessagesColumn_Recipients className="MessagesColumn_Recipients">
                                            <span>
                                                <PageText FontFamily="semibold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={ClientText} TextAlign="left" />
                                            </span>
                                            <styles.BadgeSpan Type={Type}>{Type === 'RECURRING' ? '🔄' : '📌'} {t(`message_scheduler_type_${Type.toLowerCase()}`)}</styles.BadgeSpan>
                                        </styles.MessagesColumn_Recipients>
                                        <styles.MessagesColumn_Message className="MessagesColumn_Message">{Message}</styles.MessagesColumn_Message>
                                        <styles.MessagesColumn_Scheduled className="MessagesColumn_Scheduled">
                                            <span>
                                                <PageText FontFamily="semibold" FontSize="small" JustifyContent="flex-start" NoMargin Text={moment(DueAt).format('[WeeklyViewHeader]')} TextAlign="left" />
                                            </span>
                                            <span>
                                                <PageText FontFamily="medium" FontSize="small" JustifyContent="flex-start" NoMargin Text={moment(DueAt).format('[TrackingHistoryTime]')} TextAlign="left" />
                                            </span>
                                        </styles.MessagesColumn_Scheduled>
                                        <styles.MessagesColumn_Recurrence className="MessagesColumn_Recurrence">
                                            <span>
                                                <PageText FontFamily="medium-italic" FontSize="small" JustifyContent="flex-start" NoMargin Text={RecurrencePatternString} TextAlign="left" />
                                            </span>
                                        </styles.MessagesColumn_Recurrence>
                                        <styles.MessagesColumn_Actions className="MessagesColumn_Actions">
                                            <ButtonGroup
                                                Buttons={[
                                                    { BackgroundColorHover: 'blue-astronaut', Color: 'blue-astronaut', ColorHover: 'white', FontFamily: 'semibold', OnClick: () => this.onToggleShowSendMessageModal({ ShowSendMessageModal: true, ShowSendMessageModal_Details: { ...MessageItem, ReminderMessage: MessageItem.Message, SelectedUserIds: MessageItem.ClientList.split(',').map(Number) } }), Title: t('edit_with_first_char_uppercase') },
                                                    { BackgroundColorHover: 'red-bittersweet', Color: 'red-bittersweet', ColorHover: 'white', FontFamily: 'semibold', OnClick: () => this.onToggleShowDeleteMessageModal({ ShowDeleteMessageModal: true, ShowDeleteMessageModal_Details: MessageItem }), Title: t('delete_with_first_char_uppercase') }
                                                ]}
                                                ButtonWidth="fit-content"
                                                NotTouching
                                                OwnRows
                                            />
                                        </styles.MessagesColumn_Actions>
                                    </styles.MessagesTableRow>
                                );
                            })
                        }
                    </styles.MessagesTableBody>
                </styles.MessagesTable>
            </styles.MessagesContainer>
        );
    }

    renderShowDeleteMessageModal = () => {
        var { ShowDeleteMessageModal } = this.state;

        if (ShowDeleteMessageModal) {
            var { t } = this.props;

            return (
                <Info
                    BottomButton="submit"
                    BottomButtonOnClick={this.onDeleteMessage}
                    BottomButtonText={t('delete_with_first_char_uppercase')}
                    Information={t('confirm_delete')}
                    OnHide={() => this.onToggleShowDeleteMessageModal({ ShowDeleteMessageModal: false })}
                    Show={ShowDeleteMessageModal}
                    Size="medium"
                    TextAlign="center"
                />
            );
        }
    }

    renderShowSendMessageModal = () => {
        var { ShowSendMessageModal } = this.state;

        if (ShowSendMessageModal) {
            return (
                <Info
                    BottomButton="cancel"
                    BottomButtonOnClick={() => this.onToggleShowSendMessageModal({ ShowSendMessageModal: false })}
                    InformationRenderer={this.renderShowSendMessageModalInformation}
                    Loading={this.props.TryingRemindersAction}
                    OnHide={() => this.onToggleShowSendMessageModal({ ShowSendMessageModal: false })}
                    Show={ShowSendMessageModal}
                />
            );
        }
    }

    renderShowSendMessageModalInformation = () => {
        var { t } = this.props;

        var { Device } = this.props;
        var { DateFormat, Locale, TimeFormat } = this.state;
        var { DueAt, IsAllClients, OneTimeSendNow, RecurrencePattern, ReminderMessage, SelectedUsers, SelectedUserIds, Type } = this.state.ShowSendMessageModal_Details;

        if (Type) Type = Type.toLowerCase();

        var Disabled = false;
        if (!ReminderMessage) Disabled = true;
        else if (Type === 'recurring' && !DueAt) Disabled = true;
        else if (Type === 'one_time') {
            if (+OneTimeSendNow === 0 && !DueAt) Disabled = true;
        }
        else if (!IsAllClients && SelectedUserIds.length === 0) Disabled = true;
        else if (!Type) Disabled = true;

        return (
            <>
                <PageText FontFamily="medium" FontSize="large" JustifyContent="center" NoMargin Text={t('create_new_message_schedule')} TextAlign="center" />

                <Spacer Size="medium" />

                {/* Recipients */}
                    <MultiText
                        TextAlign="left"
                        Texts={[
                            { FontFamily: 'semibold', FontSize: 'medium-1', Text: t('recipients') },
                            { FontColor: 'red-bittersweet', FontFamily: 'medium', FontSize: 'medium-2', Text: '*' },
                        ]}
                    />

                    <styles.RadioButtonParentContainer className="RadioButtonParentContainer">
                        <styles.PseudoCheckbox className="PseudoCheckbox" BackgroundColor="274775" onClick={() => this.onChangeScheduleMessage_IsAllClients(1)} Selected={IsAllClients === 1} />

                        <styles.RadioButtonPageText ElementType="span" FontFamily={IsAllClients === 1 ? 'semibold' : 'medium'} FontSize="medium-1" JustifyContent="flex-start" OnClick={() => this.onChangeScheduleMessage_IsAllClients(1)} Text={t('all_clients')} TextAlign="left" />
                    </styles.RadioButtonParentContainer>

                    <styles.RadioButtonParentContainer className="RadioButtonParentContainer">
                        <styles.PseudoCheckbox className="PseudoCheckbox" BackgroundColor="274775" onClick={() => this.onChangeScheduleMessage_IsAllClients(0)} Selected={IsAllClients === 0} />

                        <styles.RadioButtonPageText ElementType="span" FontFamily={IsAllClients === 0 ? 'semibold' : 'medium'} FontSize="medium-1" JustifyContent="flex-start" OnClick={() => this.onChangeScheduleMessage_IsAllClients(0)} Text={t('choose_clients')} TextAlign="left" />
                    </styles.RadioButtonParentContainer>

                    <Spacer Size="extra-small" />

                    <PageText FontFamily="medium-italic" FontSize="small" JustifyContent="flex-start" NoMargin Text={t('your_own_user_will_be_ignored')} TextAlign="left" />

                    <Spacer Size="extra-small" />

                    {
                        IsAllClients === 0 &&
                        <>
                            <Spacer Size="small" />

                            <AssignClients
                                HideTitle
                                HorizontalScroll={false}
                                LeftAlign
                                OnSelectClients={Users => this.onChangeScheduleMessage_ClientList(Users)}
                                SelectedUserIds={SelectedUserIds}
                                SelectedUsers={SelectedUsers}
                                WhiteBackground
                            />
                        </>
                    }

                <Spacer Size="medium" />

                {/* Schedule Type */}
                    <MultiText
                        TextAlign="left"
                        Texts={[
                            { FontFamily: 'semibold', FontSize: 'medium-1', Text: t('schedule_type') },
                            { FontColor: 'red-bittersweet', FontFamily: 'medium', FontSize: 'medium-2', Text: '*' },
                        ]}
                    />

                    <styles.RadioButtonParentContainer className="RadioButtonParentContainer">
                        <styles.PseudoCheckbox className="PseudoCheckbox" BackgroundColor="274775" onClick={() => this.onChangeScheduleMessage_ScheduleType('recurring')} Selected={Type === 'recurring'} />

                        <styles.RadioButtonPageText ElementType="span" FontFamily={Type === 'recurring' ? 'semibold' : 'medium'} FontSize="medium-1" JustifyContent="flex-start" OnClick={() => this.onChangeScheduleMessage_ScheduleType('recurring')} Text={t('message_scheduler_type_recurring')} TextAlign="left" />
                    </styles.RadioButtonParentContainer>

                    <styles.RadioButtonParentContainer className="RadioButtonParentContainer">
                        <styles.PseudoCheckbox className="PseudoCheckbox" BackgroundColor="274775" onClick={() => this.onChangeScheduleMessage_ScheduleType('one_time')} Selected={Type === 'one_time'} />

                        <styles.RadioButtonPageText ElementType="span" FontFamily={Type === 'one_time' ? 'semibold' : 'medium'} FontSize="medium-1" JustifyContent="flex-start" OnClick={() => this.onChangeScheduleMessage_ScheduleType('one_time')} Text={t('message_scheduler_type_one_time')} TextAlign="left" />
                    </styles.RadioButtonParentContainer>

                    {/* Recurrence Logic */}
                        <Spacer Size="small" />

                        {
                            Type === 'recurring' &&
                            <>
                                <styles.RecurrenceLogicContainer className="RecurrenceLogicContainer">
                                    <styles.StartDateContainer className="StartDateContainer">
                                        <PageText FontFamily="semibold" FontSize="small" JustifyContent="flex-start" NoMargin Text={t('start_date')} TextAlign="left" />

                                        <Spacer Size="extra-small" />

                                        <DateTime
                                            dateFormat={DateFormat}
                                            timeFormat={TimeFormat}
                                            onChange={this.onChangeScheduleMessage_StartDatetime}
                                            value={moment(DueAt)}
                                            locale={Locale}
                                        />

                                        <Spacer Size="extra-small" />

                                        <PageText FontFamily="medium-italic" FontSize="small" JustifyContent="flex-start" NoMargin Text={t('recurring_datetime_start_info')} TextAlign="left" />
                                    </styles.StartDateContainer>

                                    <RRuleGenerator
                                        onChange={this.onChangeScheduleMessage_RecurrencePattern}
                                        value={RecurrencePattern}
                                    />
                                </styles.RecurrenceLogicContainer>
                            </>
                        }

                    {/* One Time Logic */}
                        {
                            Type === 'one_time' &&
                            <styles.RecurrenceLogicContainer className="RecurrenceLogicContainer">
                                <styles.StartDateContainer className="StartDateContainer">
                                    <styles.RadioButtonParentContainer className="RadioButtonParentContainer">
                                        <styles.PseudoCheckbox className="PseudoCheckbox" BackgroundColor="274775" onClick={() => this.onChangeScheduleMessage_OneTimeSendNow(1)} Selected={+OneTimeSendNow === 1} />

                                        <styles.RadioButtonPageText ElementType="span" FontFamily={+OneTimeSendNow === 1 ? 'semibold' : 'medium'} FontSize="medium-1" JustifyContent="flex-start" OnClick={() => this.onChangeScheduleMessage_OneTimeSendNow(1)} Text={t('send_now')} TextAlign="left" />
                                    </styles.RadioButtonParentContainer>

                                    <styles.RadioButtonParentContainer className="RadioButtonParentContainer">
                                        <styles.PseudoCheckbox className="PseudoCheckbox" BackgroundColor="274775" onClick={() => this.onChangeScheduleMessage_OneTimeSendNow(0)} Selected={+OneTimeSendNow === 0} />

                                        <styles.RadioButtonPageText ElementType="span" FontFamily={+OneTimeSendNow === 0 ? 'semibold' : 'medium'} FontSize="medium-1" JustifyContent="flex-start" OnClick={() => this.onChangeScheduleMessage_OneTimeSendNow(0)} Text={t('choose_time')} TextAlign="left" />
                                    </styles.RadioButtonParentContainer>

                                    {
                                        +OneTimeSendNow === 0 &&
                                        <>
                                            <Spacer Size="small" />

                                            <PageText FontFamily="semibold" FontSize="small" JustifyContent="flex-start" NoMargin Text={t('start_date')} TextAlign="left" />

                                            <Spacer Size="extra-small" />

                                            <DateTime
                                                dateFormat={DateFormat}
                                                timeFormat={TimeFormat}
                                                onChange={this.onChangeScheduleMessage_StartDatetime}
                                                value={moment(DueAt)}
                                                locale={Locale}
                                            />

                                            <Spacer Size="extra-small" />

                                            <PageText FontFamily="medium-italic" FontSize="small" JustifyContent="flex-start" NoMargin Text={t('one_time_datetime_info')} TextAlign="left" />
                                        </>
                                    }

                                </styles.StartDateContainer>
                            </styles.RecurrenceLogicContainer>
                        }

                        <Spacer Size="medium" />
        
                        {/* Message Content */}
                            <MultiText
                                TextAlign="left"
                                Texts={[
                                    { FontFamily: 'semibold', FontSize: 'medium-1', Text: t('message') },
                                    { FontColor: 'red-bittersweet', FontFamily: 'medium', FontSize: 'medium-2', Text: '*' },
                                ]}
                            />
        
                            <Spacer Size="extra-extra-small" />
        
                            <styles.StyledMessageTextArea
                                OnBlur={this.onChangeScheduleMessage_Message}
                                NumRows={3}
                                Placeholder={t('enter_the_message_content')}
                                Value={ReminderMessage}
                            />

                <Spacer Size="medium" />

                <ButtonGroup
                    Buttons={[{ Color: 'blue-astronaut', FontFamily: 'semibold', Disabled, OnClick: this.onInsertEditReminder, Title: t('schedule_message') }]}
                    ButtonWidth={Device === 'mobile' || Device === 'mobile_small' ? null : 'fit-content'}
                    NotTouching
                    OwnRows={Device === 'mobile' || Device === 'mobile_small' ? true : false}
                />
            </>
        );
    }

    render() {
        var { t } = this.props;

        var { Device } = this.props;

        return (
            <>
                {(this.props.TryingRemindersAction) && <Loading />}

                <Page NoMargin>
                    <PageText FontFamily="medium" FontSize="large" JustifyContent="center" NoMargin Text={t('message_scheduler')} TextAlign="center" />

                    <Spacer Size="medium" />

                    <ButtonGroup
                        Buttons={[{ Color: 'blue-astronaut', FontFamily: 'semibold', OnClick: () => this.onToggleShowSendMessageModal({ ShowSendMessageModal: true, ShowSendMessageModal_Details: { ...DEFAULT_MESSAGE_DATA } }), Title: t('send_message') }]}
                        ButtonWidth={Device === 'mobile' || Device === 'mobile_small' ? null : 'fit-content'}
                        NotTouching
                        OwnRows={Device === 'mobile' || Device === 'mobile_small' ? true : false}
                    />

                    <Spacer Size="medium" />

                    {this.renderMessages()}
                </Page>

                {this.renderShowDeleteMessageModal()}
                {this.renderShowSendMessageModal()}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        Device: state.Window.Device,

        UserDetails: state.Auth.UserDetails,

        TryingRemindersAction: state.Reminders.TryingRemindersAction,
        TryingRemindersActionError: state.Reminders.TryingRemindersActionError
    };
};

export default withTranslation()(connect(mapStateToProps, { Reminders_DeleteReminder, Reminders_GetReminderDetail, Reminders_GetReminders, Reminders_InsertEditReminder })(MessageScheduler));